import moment from "moment";
import LabelText from "../../common/LabelText";
import LetterFooter from "../../components/LetterFooter";
import LetterHeader from "../../components/LetterHeader";
import Table from "../../common/Table";
import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import removeCommas from "../../common/removeCommas";
import { Fragment, useEffect } from "react";

const header = [
  { title: "Service Description", name: "serviceDescription" },
  { title: "Hours", name: "hours" },
  { title: "Rate", name: "rate" },
  { title: "Amount", name: "amount" },
];

const RpoTemplate = ({ data = {}, targetRef }) => {
  const details =
    data.detailsTable?.map((i) => {
      return {
        ...i,
        amount: `$ ${addPrecision(numberFormat(i.amount))}`,
      };
    }) || [];

  return (
    <div ref={targetRef} className="po-request">
      <div style={{ padding: "1cm", paddingTop: 0 }}>
        <div>
          <LetterHeader />
        </div>
        <div
          style={{
            height: "3px",
            width: "100%",
            backgroundColor: "black",
            margin: "10px 0px",
          }}
        ></div>
        <div>
          <p>
            Date : {moment(data.jobIssueDate).format("MMMM DD, YYYY")} <br />{" "}
            Job ID : {data.jobId}
          </p>

          <br />
          <br />
          <div>
            <div className="d-flex">
              <p>
                <b>Attention : </b>
              </p>
              <p
                style={{
                  maxWidth: 400,
                  paddingLeft: 5,
                  whiteSpace: "pre-line",
                }}
              >
                {` ${data.attention}`} <br />
                {data.organizationName}
                {data.organization?.careOf && (
                  <Fragment>
                    <br />
                    {data.organization?.careOf}
                  </Fragment>
                )}
                <br />
                {data.poRequestLocation}
              </p>
            </div>
          </div>
          <div>
            <br />
            <br />
            <b>
              <u>
                <p className="text-center" style={{ fontSize: 16 }}>
                  Requesting Purchase Order
                </p>
              </u>
            </b>
            <div className="d-flex">
              <span style={{ paddingRight: 10 }}>Job Location :</span>
              <p className="text-capitalize" style={{ whiteSpace: "pre-line" }}>
                {!Array.isArray(data?.location) && data.location?.title}
                {Array.isArray(data?.location) &&
                  data.location?.map((i) => `${i.title}\n`)}
              </p>
            </div>

            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <p>
                {" "}
                Starting date: {moment(data.jobStartDate).format(
                  "DD/MM/YYYY"
                )}{" "}
              </p>
              <p>
                {" "}
                Ending date: {moment(data.jobEndDate).format("DD/MM/YYYY")}{" "}
              </p>
            </div>
            <Table
              normalTable
              tableClass="table-bordered"
              header={header}
              data={details}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  width: 300,
                  gap: 10,
                  flexDirection: "column",
                }}
              >
                <LabelText
                  label="Subtotal"
                  value={`$ ${addPrecision(numberFormat(data.subtotal))}`}
                />

                <LabelText
                  label={`HST  (${data.tax}%)`}
                  value={`$ ${addPrecision(
                    (Number(removeCommas(data.subtotal)) * Number(data.tax)) /
                      100
                  )}`}
                />

                <LabelText
                  label="Total"
                  value={`$ ${addPrecision(numberFormat(data.total))}`}
                />
              </div>
            </div>
            <br />
            <br />
            <p style={{ whiteSpace: "pre-line" }}>{data.helpText}</p>
          </div>
        </div>
      </div>
      <LetterFooter />
    </div>
  );
};

export default RpoTemplate;
